const events = {
  'show.bs.modal': 'onModalShow',
  'shown.bs.modal': 'onModalShown',
  'hide.bs.modal': 'onModalHide',
  'hidden.bs.modal': 'onModalHidden'
}

export default {
  mounted () {
    for (let event in events) {
      let callback = this[events[event]]

      if (callback !== undefined) {
        window.$(this.$el).on(event, callback)
      }
    }
  },

  beforeDestroy () {
    for (let event in events) {
      let callback = this[events[event]]

      if (callback !== undefined) {
        window.$(this.$el).off(event, callback)
      }
    }
  },

  methods: {
    showModal () {
      window.$(this.$el).modal('show')
    },

    hideModal () {
      window.$(this.$el).modal('hide')
    }
  }
}
